import { TRADEXRADAR_SNAPSHOT_URL } from '@/config/apiConfig';
import type { MarketDataSnapshot } from '@/models/marketData';
import { normalizeTradeXRadar } from '@/models/tradeXRadar';

export interface FetchMarketDataOptions { signal?: AbortSignal }
export interface IMarketDataService {
  fetchMarketData(options?: FetchMarketDataOptions): Promise<MarketDataSnapshot>;
}
export class JsonMarketDataService implements IMarketDataService {
  constructor(private readonly url: string) {}
  async fetchMarketData(options: FetchMarketDataOptions = {}): Promise<MarketDataSnapshot> {
    const response = await fetch(this.url, {
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
      },
      signal: options.signal,
    });
    if (!response.ok) throw new Error('Unable to refresh market data. Please try again.');
    try {
      return normalizeTradeXRadar(await response.json());
    } catch (error) {
      if (import.meta.env.DEV) console.warn('Invalid TradeXRadar snapshot', error);
      throw new Error('The market data response could not be read. Please try again.');
    }
  }
}
export const marketDataService = new JsonMarketDataService(TRADEXRADAR_SNAPSHOT_URL);
